import {
  AccountServicePath,
  CANDIDACIES,
  CANDIDACIES_PRELIMINARY,
  CANDIDACIES_REGULAR,
  CandidateServicePath,
  ReportingServicePath,
  REPORTS,
  REPORTS_FINANCIAL,
  REPORTS_PRELIMINARY_CANDIDATE,
  CANDIDATE_USERS,
  USERS,
  STUDY_DEPARTMENT_INFO,
  STRUCTURAL_UNITS,
  AdministrationServicePath,
  CANDIDACIES_PAID,
  CANDIDACIES_COURSES,
  CANDIDACIES_HOSPITAL_CONTRACTS,
  StudentServicePath,
  SEMESTERS,
  ACADEMIC_SESSIONS,
  SESSIONS,
  ATTESTATIONS_INCOMPLETE_SEMESTERS,
  ATTESTATIONS,
  INCOMPLETE_SEMESTERS,
  NotificationServicePath,
  EMAIL_GROUPS,
  EMAILS_GROUPS,
  SENT_EMAILS,
  STUDENTS,
  STUDENTS_PATH,
  EDUCATION_PREPARATORY,
  EDUCATION_STUDENTS,
  ActivityServicePath,
  FOREIGN_LANGUAGES,
  ACTIVITIES,
  SPORTS,
  MANAGE_CAPACITY,
  CAPACITIES,
  EVENTS,
  ALUMNI,
  AlumniServicePath,
  ScholarshipServicePath,
  APPLICATIONS,
  SpecialistServicePath,
  HEALTHCARE_COURSE_FEE_DISTRIBUTION,
  HEALTHCARE_COURSES,
  FEE_DISTRIBUTION,
  EMAILS,
  REPORTS_ACADEMIC,
  REPORTS_STUDENT,
  ACADEMIC_REQUESTS,
  ACADEMIC_REQUEST_DATA_ISSUES,
  DATA_ISSUES,
  WEEKLY_SCHEDULE_NON_WORKING_OCCURRENCES,
  NON_WORKING_OCCURRENCES,
  ErasmusServicePath,
  TEACHERS_OUTGOING_ERASMUS,
} from "utils/constants";
import { settings } from "./settings";

const urlGenerators = [
  resource => {
    // Reports
    if (resource === ReportingServicePath + REPORTS_PRELIMINARY_CANDIDATE) return ReportingServicePath + REPORTS;
    if (resource === ReportingServicePath + REPORTS_FINANCIAL) return ReportingServicePath + REPORTS;
    if (resource === ReportingServicePath + REPORTS_ACADEMIC) return ReportingServicePath + REPORTS;
    if (resource === ReportingServicePath + REPORTS_STUDENT) return ReportingServicePath + REPORTS;

    //Attestations
    if (resource === StudentServicePath + ATTESTATIONS_INCOMPLETE_SEMESTERS)
      return StudentServicePath + ATTESTATIONS + "/" + INCOMPLETE_SEMESTERS;

    // Academic requests
    if (resource === StudentServicePath + ACADEMIC_REQUEST_DATA_ISSUES)
      return StudentServicePath + ACADEMIC_REQUESTS + "/" + DATA_ISSUES;

    //Sessions and Semesters
    if (resource === StudentServicePath + SEMESTERS) return StudentServicePath + ACADEMIC_SESSIONS;
    if (resource === StudentServicePath + SESSIONS) return StudentServicePath + ACADEMIC_SESSIONS;

    // Notifications
    if (resource === NotificationServicePath + SENT_EMAILS) return NotificationServicePath + EMAILS;
    if (resource === NotificationServicePath + EMAIL_GROUPS) return NotificationServicePath + EMAILS_GROUPS;

    // Candidacies
    if (resource === CandidateServicePath + CANDIDACIES_PRELIMINARY) return CandidateServicePath + CANDIDACIES;
    if (resource === CandidateServicePath + CANDIDACIES_REGULAR) return CandidateServicePath + CANDIDACIES;
    if (resource === CandidateServicePath + CANDIDACIES_PAID) return CandidateServicePath + CANDIDACIES;
    if (resource === CandidateServicePath + CANDIDACIES_COURSES) return CandidateServicePath + CANDIDACIES;
    if (resource === CandidateServicePath + CANDIDACIES_HOSPITAL_CONTRACTS) return CandidateServicePath + CANDIDACIES;

    //Users
    if (resource === AccountServicePath + CANDIDATE_USERS) return AccountServicePath + USERS;
    if (resource === STUDENTS_PATH + "/" + EDUCATION_STUDENTS) return STUDENTS;
    if (resource === STUDENTS_PATH + "/" + EDUCATION_PREPARATORY) return STUDENTS;

    // Study Department Info
    if (resource === AdministrationServicePath + STUDY_DEPARTMENT_INFO)
      return AdministrationServicePath + STRUCTURAL_UNITS + "/" + STUDY_DEPARTMENT_INFO;

    // Activities
    if (resource === ActivityServicePath + ACTIVITIES + "/" + FOREIGN_LANGUAGES)
      return ActivityServicePath + FOREIGN_LANGUAGES + "/" + ACTIVITIES;
    if (resource === ActivityServicePath + ACTIVITIES + "/" + SPORTS)
      return ActivityServicePath + SPORTS + "/" + ACTIVITIES;

    if (resource === MANAGE_CAPACITY + "/" + FOREIGN_LANGUAGES)
      return ActivityServicePath + FOREIGN_LANGUAGES + CAPACITIES;

    //Alumni
    if (resource === EVENTS) return AlumniServicePath + ALUMNI + "/" + EVENTS;
    if (resource === ALUMNI) return AlumniServicePath + ALUMNI;

    // Scholarships
    if (resource === ScholarshipServicePath + "approved/" + APPLICATIONS)
      return ScholarshipServicePath + APPLICATIONS + "/approved";

    if (resource === SpecialistServicePath + HEALTHCARE_COURSE_FEE_DISTRIBUTION)
      return SpecialistServicePath + HEALTHCARE_COURSES + "/" + FEE_DISTRIBUTION;

    if (resource === StudentServicePath + NON_WORKING_OCCURRENCES)
      return StudentServicePath + WEEKLY_SCHEDULE_NON_WORKING_OCCURRENCES;

    // Erasmus - employee's own outgoing mobilities. The menu/route name is decoupled from the API
    // path (so "my" is never matched as an :id of the outgoing-employees resource); map it here.
    if (resource === ErasmusServicePath + "my-outgoing-mobilities")
      return ErasmusServicePath + TEACHERS_OUTGOING_ERASMUS + "/my";

    // if(resource === "manage-entry-exams/foreign-languages")
    //   return `/activity/students/foreign-languages/${foreignLanguageId}/levels/assignments`

    return null;
  },
];

export const urlGenerator = resource => {
  let apiPath;

  for (let i = 0; i < urlGenerators.length; i++) {
    apiPath = urlGenerators[i](resource);

    if (apiPath) break;
  }

  return `${settings.gatewayApi}/${apiPath || resource}`;
};
